var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from './combine-reducers';
export var removeAllInjectedReducers = function (_a) {
    var store = _a.store, reducersNotToReplace = _a.reducersNotToReplace;
    // get injected reducers
    var asyncReducers = store.asyncReducers;
    var rootReducers = store.rootReducers;
    // get all reducers from the store
    var storeState = store.getState();
    var constantAsyncReducers = Object.keys(asyncReducers).reduce(function (acc, asyncReducerName) {
        var _a;
        var isAsyncReducerStable = Boolean(reducersNotToReplace.find(function (reducerName) { return reducerName === asyncReducerName; }));
        if (isAsyncReducerStable) {
            return __assign(__assign({}, acc), (_a = {}, _a[asyncReducerName] = asyncReducers[asyncReducerName], _a));
        }
        return acc;
    }, {});
    // get replaced result
    var replacedResult = Object.keys(storeState).reduce(function (acc, reducerName) {
        return asyncReducers[reducerName]
            ? acc
            : __assign(__assign({}, acc), { reducerName: storeState[reducerName] });
    }, {});
    // clear injected reducers registry
    store.asyncReducers = __assign({}, constantAsyncReducers); // eslint-disable-line
    // create new reducer
    var updatedReducers = combineReducers(__assign(__assign(__assign({}, replacedResult), constantAsyncReducers), rootReducers));
    // update reducers
    store.replaceReducer(updatedReducers);
};
